import BaseEnum from './BaseEnum';

class AbandonedOrders extends BaseEnum {
  fieldsMap = {
    Source: 'Source',
    BranchId: 'Branch Id',
    Customer: 'Customer',
    Status: 'Status',
    OrderDate: 'Order Date',
    OrderMonth: 'Order Month',
    Territory: 'Territory',
    OrderCount: 'Order Count',
    Quantity: 'Quantity',
    ContactName: 'Contact Name',
    Email: 'Email',
    PhoneNumber: 'Phone Number',
    Brand: 'Brand',
    Address: 'Address',
  }
}

export default AbandonedOrders.make();